<template>
    <client-page>
        <v-container>
            <div class="tit-wrap text-center">
                <h2 class="tit tit--lg">Artists</h2>
            </div>

            <div class="tab-wrap">
                <author-list-search v-bind="{ summary }" />
            </div>

            <v-row>
                <template v-for="author in authors">
                    <v-col cols="12" md="3" :key="author._id">
                        <author-list-item v-bind="{ author }" />
                    </v-col>
                </template>
            </v-row>

            <div class="v-pagination-wrap">
                <v-pagination :value="page" :length="pageCount" :total-visible="20" class="my-2" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
            </div>
            <v-fade-transition leave-absolute>
                <v-overlay v-show="loading" color="white" light>
                    <v-progress-circular color="primary" indeterminate size="100" width="5" />
                </v-overlay>
            </v-fade-transition>
        </v-container>
    </client-page>
</template>

<script>
import api from "@/api";

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import AuthorListItem from "@/components/client/auction/authors/author-list-item.vue";
import AuthorListSearch from "@/components/client/auction/authors/author-list-search.vue";

export default {
    components: {
        ClientPage,
        AuthorListItem,
        AuthorListSearch,
    },
    data: () => ({
        authors: [],

        limit: 16,
        summary: { totalCount: 0 },

        loading: false,
    }),
    computed: {
        items() {
            return [...this.authors];
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        sort() {
            const { sort } = this.$route.query;
            return sort ?? JSON.stringify({ index: -1, createdAt: -1 });
        },
        params() {
            let { ...query } = this.$route.query;

            delete query.page;
            delete query.sort;

            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        async init() {
            this.authors = [];
            this.summary.totalCount = 0;

            this.search();
        },
        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { skip, limit, sort, params } = this;
                const { authors, summary } = await api.v1.auction.authors.gets({
                    headers: { skip, limit, sort },
                    params,
                });

                this.authors = authors;
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
